import { mobile } from '@/utils/IE';

const PageId = {
  get: () => document.body.getAttribute('dt-pgid'),
  set: (id) => {
    document.body.setAttribute('dt-pgid', id);
  },
};
// const Lang = { 'zh-CN': 0, 'en-US': 1 };
// 上报渠道来源
const Channel = { search: 1, wechat: 2, email: 3 };
// 上报搜索来源只判断这4家搜索平台标识
const Search = 'baidu|google|so|sogou';
// 上报页面的路由别名（避免干扰业务路由跳转，这里做上报别名映射）
const RouterReflect = {};

const myConsole = (obj) => {
  console.warn('report params == > ', obj);
};

class SetReport {
  constructor() {
    this.InitReport();
  }

  Send(type, params = '') {
    if (type && this[type]) {
      this[type](params);
    } else {
      throw new Error(`'${type}' method is not exist in report Class`);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  pageIn(params) {
    if (params) {
      // PageId.set(`page_${(RouterReflect[params] || params).toLowerCase()}`);
      this.sendReport
        .setPage(
          {
            pgid: `${(RouterReflect[params] || params).toLowerCase()}`,
          },
          document.body,
        )
        .observe(`${(RouterReflect[params] || params).toLowerCase()}`);
    }
  }

  pageOut(params) {
    if (params) {
      console.log(params, '===============================sss');
      const name = params.toLowerCase();
      this.sendReport.reportPgOut(`${RouterReflect[name] || name}`, true);
      // this.sendReport.reportPgOut(`${(RouterReflect[params] || params).toLowerCase()}`, true);
    }
  }

  reportEvent(params = {}) {
    myConsole(params);
    // * dt_imp     元素曝光
    // * dt_clck    元素点击
    // * dt_imp_end 元素结束曝光
    this.sendReport.reportEvent({
      pgid: PageId.get(),
      eventName: params.eventName || 'dt_clck',
      businessParams: {
        eid: params.eid,
        ...{ ...params.extParams },
      },
    });
  }

  // 重置用户公共参数
  ResetUserPublic() {
    this.SetPublic({
      user_id: '',
      user_type: '',
      applicant_type: '',
    });
  }

  // 公共参数设定
  SetPublic(params) {
    if (this.sendReport) {
      this.sendReport.setPublicParams(params);
    } else {
      this.InitReport(params);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getSource() {
    const Params = window.location.hash.match(/source=(\w+)/i);
    if (Params === null) {
      const { referrer } = document;
      if (referrer) {
        const Host = referrer.match(/http(s)?:\/\/(.*?)\//i);
        if (Host[0].match(new RegExp(Search, 'i'))) {
          return Channel.search;
        }
      }
      return 0;
    }
    return Channel[Params[1]] || 0;
  }

  // 初始化大同上报，接受设定公共参数
  InitReport(params = {}) {
    // 大同业务数据上报
    try {
      this.sendReport = new window.UniversalReport({
        beacon: '0WEB01PPJB5MX8RM',
        // 初始公共参数
        publicParams: {
          platform: mobile ? 'h5' : 'web',
          is_test: process.env.NODE_ENV === 'production' ? 0 : 1,
          is_env: process.env.VUE_APP_REPORT,
          language: 'zh-CN',
          source_user: this.getSource(),
          ...params,
        },
      });
    } catch (err) {
      this.sendReport = {
        reportPgOut: () => {},
        reportEvent: () => {},
        setPublicParams: () => {},
      };
    }
  }
}

const setReport = new SetReport();

export { setReport };
